import React from 'react';

const Content = ({ children }) => (
  <div className="layout__content">{children}</div>
);

export default Content;



// WEBPACK FOOTER //
// ./src/components/Common/Content/Content.js